<template>
	<div>
		<div v-if="isUserAllowedInLevel5or6">
			<BaseHeader :title="$t('absence_planner').toString()">
				<div class="flex items-center">
					<BaseButton class="btn-blue" @click="$router.push({ name: 'vacations.create_vacation' })">
						{{ $t('save_absence') }}
					</BaseButton>
				</div>
			</BaseHeader>
			<div class="main" v-if="!isLoading">
				<div class="flex space-x-6">
					<BaseSelect
						:filter-only="true"
						v-model="selectedEmployee"
						:options="employees"
						@input="getCompanyVacations"
						class="w-56"
						:label="$t('employees')"
					/>
					<BaseSelect :filter-only="true" v-model="filter" :options="filterOptions" @input="getCompanyVacations" class="w-56" label="Status" />
				</div>
				<div class="mt-6">
					<div class="align-middle inline-block min-w-full shadow overflow-hidden border-b border-gray-200 rounded">
						<table class="min-w-full" v-if="this.vacations && this.vacations.length > 0">
							<thead>
								<tr class="justify-start">
									<OverviewTableHeader :cursor-pointer="false" :label="$t('period').toString()" />
									<OverviewTableHeader :cursor-pointer="false" :label="$t('applicant').toString()" />
									<th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-center"></th>
								</tr>
							</thead>
							<tbody class="bg-white">
								<tr
									v-for="vacation in this.vacations"
									:key="vacation.id"
									class="tr odd:bg-gray-200 rounded"
									@click="$router.push({ name: 'repair_shop.company_ads.ad_preview', params: { id: ad.id } })"
									:class="{ 'cursor-pointer': false }"
								>
									<td class="px-6 py-4">{{ formatDate(vacation.start) }} - {{ formatDate(vacation.end) }}</td>
									<td class="px-6 py-4">{{ vacation.created_by.firstName }} {{ vacation.created_by.lastName }}</td>
									<td class="px-6 py-4 whitespace-no-wrap text-right text-lg font-medium">
										<font-awesome-icon
											:icon="['fas', 'edit']"
											@click.stop="$router.push({ name: 'vacations.create_vacation', params: { id: vacation.id } })"
											class="cursor-pointer mr-4"
										/>
										<font-awesome-icon
											:icon="['fas', 'trash-alt']"
											class="cursor-pointer"
											@click.stop="deleteVacation(vacation.id)"
											:title="$t('remove').toString()"
										/>
									</td>
								</tr>
							</tbody>
						</table>
						<div v-else class="font-bold bg-gray-50 mt-3 mb-3">{{ $t('none_available') }}</div>
					</div>
				</div>
				<router-view />
			</div>
			<LoadingSpinner v-else />
		</div>
		<div v-else>
			<Forbidden />
		</div>
	</div>
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import { RepairshopsApiFactory, UserApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseButton from '@/components/forms/buttons/BaseButton';
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import LoadingSpinner from '@/components/navigation/LoadingSpinner';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden';
import RouteWatcher from '@/mixins/RouteWatcher';
import OverviewTableHeader from '@/views/damagecases/OverviewTableHeader.vue';
import { getGermanDate } from '@/plugins/Utils';

export default {
	name: 'Vacation',
	components: { OverviewTableHeader, Forbidden, LoadingSpinner, BaseSelect, BaseButton, BaseHeader },
	mixins: [Authentication, RouteWatcher],
	data() {
		return {
			company: null,
			isLoading: false,
			vacations: [],
			filterOptions: [
				{
					display: this.$t('future'),
					value: 'future',
				},
				{
					display: this.$t('past'),
					value: 'past',
				},
				{
					display: this.$t('all'),
					value: 'all',
				},
			],
			filter: {
				display: this.$t('future'),
				value: 'future',
			},
			employees: [],
			selectedEmployee: null,
		};
	},
	mounted() {
		if (this.isUserAllowedInLevel5or6) {
			this.isLoading = true;
			// this.getCompanyVacations();
			this.getEmployees();

			this.$root.$on('updateVacations', () => {
				this.getCompanyVacations();
			});
		}
	},
	methods: {
		onRouteChange() {},
		formatDate(timestamp) {
			return getGermanDate(timestamp);
		},
		getEmployees() {
			UserApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.userGet()
				.then(response => {
					this.employees = [];
					response.data.map(option => {
						option.value = option.person.id;
						option.display = option.person.firstName + ' ' + option.person.lastName;
						this.employees.push(option);
						if (this.getUser.person.id === option.person.id) {
							this.selectedEmployee = option;
						}
					});
				})
				.finally(_ => {
					this.getCompanyVacations();
				});
		},
		getCompanyVacations() {
			this.isLoading = true;
			RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.repairshopVacationsGet(this.selectedEmployee.person.id, this.filter.value)
				.then(response => {
					this.vacations = response.data.data;
					this.isLoading = false;
				});
		},
		deleteVacation(vacationID) {
			this.$swal({
				title: this.$t('sure').toString(),
				text: this.$t('delete_absence').toString(),
				icon: 'warning',
				cancelButtonText: this.$t('general.no').toString(),
				showCancelButton: true,
				confirmButtonText: this.$t('general.yes').toString(),
			}).then(result => {
				if (result.value) {
					RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
						.repairshopVacationsIdDelete(vacationID)
						.then(response => {
							this.$swal(this.$t('general.success').toString(), this.$t('deleted_absence').toString(), 'success').then(_ => {
								this.getCompanyVacations();
							});
						})
						.catch(e => {
							this.$swal(this.$t('general.error').toString(), this.$t('delete_absence_error').toString(), 'error');
						});
				}
			});
		},
		onDayClicked() {},
	},
};
</script>
